var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('b-row',{staticClass:"mt-5"},[_c('b-col',{attrs:{"cols":"6"}},[_c('correct-words',{on:{"wordSelected":(data)=>{ _vm.wordSelected = data },"wordSelectedNull":function($event){return _vm.test()}}})],1),_c('b-col',{attrs:{"cols":"6"}},[_c('bad-words',{attrs:{"wordSelected":_vm.wordSelected}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }